/* eslint-disable react/jsx-props-no-spreading */
import { arrayOf, node, oneOfType, string } from 'prop-types';
import _, { castArray } from 'lodash';
import { Button, Dialog, DialogActions, DialogContent, Typography } from '@material-ui/core';
import { Trans } from '@lingui/macro';
import { NavigateBefore } from '@material-ui/icons';

import { useRole } from '../../stores/SessionStore';
import { ColumnFlexLayout } from '../layout';
import { useLastLocationUrl } from '../side-nav/SidebarLocationHistory';
import Link from '../links/Link';

/**
 * This is a higher-order component that is meant to be used as an auth-guard on protected routes.
 */
export default function AuthRoleGuard(props) {
    const { children, allowedRoles } = props;
    const [role] = useRole();

    return _.includes(castArray(allowedRoles), role) ? children : <NotAuthorizedWarning />;
}

AuthRoleGuard.propTypes = {
    children: node.isRequired,
    allowedRoles: oneOfType([arrayOf(string), string]),
};

AuthRoleGuard.defaultProps = {
    allowedRoles: ['admin', 'super', 'user'],
};

function NotAuthorizedWarning() {
    const lastUrl = useLastLocationUrl();

    return (
        <Dialog open>
            <ColumnFlexLayout hRight>
                <DialogContent>
                    <Typography variant="subtitle2">
                        <Trans>You do not have the necessary authorization to view this page</Trans>
                    </Typography>
                </DialogContent>

                <DialogActions>
                    <Button
                        variant="outlined"
                        size="small"
                        component={Link}
                        to={lastUrl}
                        startIcon={<NavigateBefore />}
                    >
                        <Trans>Go Back</Trans>
                    </Button>
                </DialogActions>
            </ColumnFlexLayout>
        </Dialog>
    );
}
